import React from 'react';

import RequestDeniedLayoutPartners from 'containers/direto/error-message/request-denied-layout-partners';

const LoanDeniedPage: React.FC = () => <RequestDeniedLayoutPartners />;

export default LoanDeniedPage;
